import controller from './choose-line.controller';

function routeConfig($stateProvider) {
	'ngInject';

	$stateProvider
		.state('app.private.seats.chooseLine', {
			controller,
			'template': `<section ng-include="'partials/choose-line.html'"></section>`,
			'url': '/choose-line',
			'controllerAs': 'vm',
			'resolve': {
				'activate': function(LineComponent) {
					'ngInject';

					return LineComponent.fetchLines();
				}
			}
		});
}

export default routeConfig;



/** WEBPACK FOOTER **
 ** ./client/private/seats/choose-line/choose-line.route.js
 **/